import React from 'react';
import ReadinessRing from './ReadinessRing';
import TrendArrow from './TrendArrow';

export default function StudyUnitCard({ unit, readiness, trend, totalMembers, ratedMembers, open, allStrong, onClick }) {
  const notStarted = readiness == null;
  const cardClass = [
    'tv3-su-card',
    notStarted ? 'tv3-not-started' : '',
    open ? 'tv3-open' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClass} onClick={onClick}>
      <div className="tv3-ring-wrap">
        <ReadinessRing value={readiness} />
        {!notStarted && <TrendArrow direction={trend || 'stable'} />}
      </div>
      <div className="tv3-su-info">
        <div className="tv3-su-name">{unit.name || unit.general_topic}</div>
        <div className="tv3-su-meta">{ratedMembers} of {totalMembers} subtopics rated</div>
      </div>
      {allStrong && !open && (
        <span className="tv3-completed-badge">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          All strong
        </span>
      )}
      <span className={`tv3-chevron${open ? ' tv3-open' : ''}`}>›</span>
    </div>
  );
}
